module.exports = __webpack_public_path__ + "img/app_collage.30d4ae91.png";